import React, { Component } from "react";
import moment from "moment";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
import Table from "../../components/Table";

class ListHotelScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  onDelete = async (item) => {};
  onEdit = async (item) => {};
  onView = async (item) => {
    this.props.setSelectedHotelId(item.id);
  };

  render() {
    return (
      <div>
        <h1>Restaurants</h1>
        <Table
          api={URL_PATH.listHotel}
          onRowClick={this.onView}
          onEdit={this.onEdit}
          onView={this.onView}
          onDelete={this.onDelete}
          row={[
            {
              title: "Id",
              key: "id",
              sortable: true,
            },
            {
              title: "Name",
              key: "name",
              sortable: true,
            },
            {
              title: "Address",
              key: "address",
              sortable: false,
            },
            // {
            //     title: "phone",
            //     key: "phone",
            //     sortable: true,
            // },
            {
              title: "Email",
              key: "email",
              sortable: true,
            },
            {
              title: "Description",
              key: "description",
              sortable: false,
            },
          ]}
        />
      </div>
    );
  }
}

export default redux(ListHotelScreen);
